import { z } from 'zod';
export const SyncIntervalSecondsSchema = z.union([
    z.literal(30),
    z.literal(60),
    z.literal(300),
]);
export const IdleDisplaySchema = z.enum(['logo', 'clock', 'black']);
export const OrganisationSettingsSchema = z.object({
    timezone: z.string().min(1).max(64),
    defaultPlaylistId: z.string().min(1).nullable(),
    syncIntervalSeconds: SyncIntervalSecondsSchema,
    idleDisplay: IdleDisplaySchema,
});
export const UpdateOrganisationSettingsRequestSchema = z
    .object({
    timezone: z.string().min(1).max(64).optional(),
    defaultPlaylistId: z.string().min(1).nullable().optional(),
    syncIntervalSeconds: SyncIntervalSecondsSchema.optional(),
    idleDisplay: IdleDisplaySchema.optional(),
})
    .refine((value) => value.timezone !== undefined ||
    value.defaultPlaylistId !== undefined ||
    value.syncIntervalSeconds !== undefined ||
    value.idleDisplay !== undefined, { message: 'Provide at least one setting to update' });
//# sourceMappingURL=organisation-settings.js.map